import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';
export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState: {
    snackbars: [],
    modal: {
      open: false,
      message: '',
      severity: 'info',
      duration: null,
    },
  },
  reducers: {
    showSnackbar: (state, action) => {
      const id = uuidv4(); // Generates a truly unique ID
      state.snackbars.push({
        id,
        message: action.payload.message,
        duration: action.payload.duration || 2500,
        severity: action.payload.severity || 'info',
      });
    },
    removeSnackbar: (state, action) => {
      state.snackbars = state.snackbars.filter(
        snackbar => snackbar.id !== action.payload
      );
    },

    clearAllSnackbars: (state) => {
      state.snackbars = [];
      state.modal = {  
        open: false,
        message: '',
        severity: 'info',
        duration: null,
      };
    },
    showModal: (state, action) => {
      state.modal = {
        open: true,
        message: action.payload.message,
        severity: action.payload.severity || 'info',
        duration: action.payload.duration || 2500,
      };
    },
    hideModal: (state) => {
      state.modal = {
        open: false,
        message: '',
        severity: 'info',
        duration: null,
      };
    },
  },
});

export const { showSnackbar, removeSnackbar, clearAllSnackbars, showModal, hideModal} = snackbarSlice.actions;

// Selectors
export const selectSnackbars = (state) => state.snackbar.snackbars;
export const selectModal = (state) => state.snackbar.modal;
export default snackbarSlice.reducer;